module.exports = __webpack_public_path__ + "img/logo_smarky_ol.c18e888b.png";